import { useMemo } from 'react';
import { AutoCompleteSuggestionProps } from '../components/forms/Autocomplete';
import { useAutoCompleteSearchLazyQuery } from '../types/graphqlHelpers';
import { SearchCategory, SearchType } from '../types/graphqlTypes';

interface UseAutoCompleteReturn {
  autoCompleteSuggestions?: AutoCompleteSuggestionProps[];
  handleAutoComplete: (value: string) => void;
  loading: boolean;
}

interface UseAutoCompleteProps {
  category: SearchCategory;
  type: SearchType;
}
export const UseAutoComplete = ({ category, type }: UseAutoCompleteProps): UseAutoCompleteReturn => {
  // Hook to retrieve Autocomplete location values
  const [getAutocomplete, { data: autoCompleteData, loading }] = useAutoCompleteSearchLazyQuery();

  // Handle Autocomplete
  const handleAutoComplete = (value: string) => getAutocomplete({ variables: { search: value, category, type } });

  //  Auto search results mapping
  const autoCompleteSuggestions = useMemo(
    () =>
      autoCompleteData?.propertySearchMeta?.autoComplete?.autoCompleteItems?.map(
        (item) =>
          ({
            name: item.displayName,
            value: item.multiSearch,
          } as AutoCompleteSuggestionProps)
      ),
    [autoCompleteData]
  );

  return {
    autoCompleteSuggestions,
    handleAutoComplete,
    loading,
  };
};
